(function() {
    'use strict';

a3_cabin_reports.directive('flightHeader',flightHeader);
    
    
 /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name flightHeader
   * @restrict E
   * @description
   *   Implementation of flightHeader
   *    Initialize the template of the header while you are in the Flight Level
   * @example
   *   Usage:
   *   <flight-header></flight-header>
   * @ngInject 
   */      
function flightHeader () {
		return {
			restrict: 'E',
			terminal: true,
			templateUrl: "views/Flight/header.tpl.html",
			scope: false
		}
	} 

})();
